import LeadGuarantee from 'app/shared/model/LeadGuarantee';
import PaidInclusion from 'app/shared/model/PaidInclusion';

const CurrentProperty = ({
    street = '',
    city = '',
    state = '',
    zip = '',
    unit = '',
    active = false,
    autoBill = false,
    numUnits = '',
    archived = false,
    canBeArchived = true,
    isAddressEditable = true,
    hasVrModels = false,
    isEditable = true,
    leadGuarantee = {},
    paidInclusion = {},
    propertyType = '',
    dateLastActivated = '',
    expirationDate = '',
    numLeadsSinceLastActivated = 0,
    isAddressValid = true,
} = {}) => ({
    street: String(street),
    city: String(city),
    state: String(state),
    zip: String(zip),
    unit: String(unit),
    active: Boolean(active),
    numUnits: String(numUnits),
    archived: Boolean(archived),
    autoBill: Boolean(autoBill),
    canBeArchived: Boolean(canBeArchived),
    isAddressEditable: Boolean(isAddressEditable),
    hasVrModels: Boolean(hasVrModels),
    isEditable: Boolean(isEditable),
    leadGuarantee: LeadGuarantee(leadGuarantee),
    paidInclusion: PaidInclusion(paidInclusion),
    propertyType: String(propertyType),
    dateLastActivated: String(dateLastActivated),
    expirationDate: String(expirationDate),
    numLeadsSinceLastActivated: Number(numLeadsSinceLastActivated),
    isAddressValid: Boolean(isAddressValid),
});

export default CurrentProperty;
